import React, {Component} from "react";
import {Alert, FormGroup, Row, Col, Modal, Button, Card, CardBody, Label} from "reactstrap";
import {connect} from "react-redux";
import {withTranslation} from "react-i18next";
import * as Yup from "yup";
import {ErrorMessage, Field, Form, Formik, FieldArray} from "formik";
import SelectField from "../../components/Common/SelectField";
import PropTypes from "prop-types";
import {slipDetail, slipQRUpdate, slipSelect, slipUpdate} from "../../store/slip/actions";
import FileViewer from "../../components/Common/FileViewer";

const slipDataDefault = {
  qrvalue: "",
  crn: "",
  date: "",
}

class SlipDetailModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      slipData: slipDataDefault,
      select: null,
      slipDataLoaded: false,
      loadingDetail: false,
      errorDetail: "",
      loadingSelect: false,
      errorSelect: "",
      loadingUpdate: false,
      errorUpdate: "",
    }
    this.onClose = this.onClose.bind(this)
    this.onBlurCrn = this.onBlurCrn.bind(this)
    this.onReprocess = this.onReprocess.bind(this)
  }

  componentDidMount() {
    this.props.onSlipDetail({sign: this.props.slipData.sign, history: this.props.history});
  }

  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      this.setState({
        slipData: this.props.responseDetail ? this.props.responseDetail.response.slipData : slipDataDefault,
        select: this.props.responseSelect ? this.props.responseSelect.response.select : null,
        slipDataLoaded: !!this.props.responseDetail,
        loadingDetail: this.props.loadingDetail,
        errorDetail: this.props.errorDetail,
        loadingSelect: this.props.loadingSelect,
        errorSelect: this.props.errorSelect,
        loadingUpdate: this.props.loadingUpdate,
        errorUpdate: this.props.errorUpdate,
      });

      if (this.state.select === null && this.props.responseDetail && this.props.responseDetail.response.slipData.crn && this.props.responseDetail.response.slipData.crn.length > 0) {
        this.props.onSlipSelect({section_id: this.props.slipData.sectionId, supplier_crn: this.props.responseDetail.response.slipData.crn, history: this.props.history});
      }

      if ((this.props.responseUpdate && this.props.responseUpdate.status === 0) || (this.props.responseQRUpdate && this.props.responseQRUpdate.status === 0)) {
        this.onClose()
      }
    }
  }

  onClose = () => {
    this.props.togModal()
    this.props.refreshParent()
  }

  onBlurCrn = (e) => {
    if (e.target.value.length >= 3) {
      this.props.onSlipSelect({section_id: this.props.slipData.sectionId, supplier_crn: e.target.value, history: this.props.history});
    }
  }

  onReprocess = (qrvalue) => {
    if (qrvalue.length > 3) {
      this.props.onSlipQRUpdate({sign: this.props.slipData.sign, data: {slip_value: qrvalue}, history: this.props.history})
    }
  }

  totalRowValidate = (values) => {
    let total = 0;

    values.transactions.forEach(transaction => {
      total += transaction.total;
    })

    if (Math.abs(parseFloat(values.total) - total) < 0.05) {
      return {}
    }

    return {background: "#FFF5F5"}
  }

  transactionRowValidate = (transaction) => {
    if (Math.abs((parseFloat(transaction.base) + parseFloat(transaction.vat)) - parseFloat(transaction.total)) < 0.05 && Math.abs((parseFloat(transaction.base) / parseFloat(transaction.vat)) - (100 / parseFloat(transaction.vatRate.value))) < 0.05) {
      return {}
    }

    return {background: "#FFF5F5"}
  }

  render() {
    return (<React.Fragment>
      <Modal isOpen={true} toggle={this.onClose} className="xxl-modal" contentClassName="xxl-modal-content">
        <div className="modal-header">
          <h5 className="modal-title mt-0">
            Slip Detail
          </h5>
          <button type="button" onClick={this.onClose} className="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <Card>
          <CardBody>
            <Row className="mb-2">
              <Col className="col-4" style={{"height": "85vh", "overflow": "scroll"}}>
                {this.state.slipDataLoaded && <Formik
                  initialValues={this.state.slipData}
                  validationSchema={Yup.object().shape({
                    qrvalue: Yup.string().required("Please Enter QR Code"),
                    crn: Yup.string().required("Please Enter Crn"),
                    date: Yup.date().required("Please Enter Date"),
                    total: Yup.number().required("Please Enter Total"),
                    transactions: Yup.array()
                      .of(
                        Yup.object().shape({
                          base: Yup.number().typeError("Base must be a number").required("Please enter Base"),
                          vatRate: Yup.object().typeError("Choose a Vat Rate"),
                          vat: Yup.number().typeError("Vat must be a number").required("Please enter Vat"),
                          total: Yup.number().typeError("Total must be a number").required("Please enter Total"),
                          account: Yup.object().typeError("Choose an Account"),
                        })
                      )
                  })}
                  onSubmit={values => {
                    let newValues = {
                      value: values.qrvalue,
                      crn: values.crn,
                      date: values.date,
                      total: values.total,
                      transactions: [...values.transactions],
                    }
                    newValues = JSON.parse(JSON.stringify(newValues));
                    for (let i = 0; i < newValues.transactions.length; i++) {
                      newValues.transactions[i].vat_rate = newValues.transactions[i].vatRate.value
                      newValues.transactions[i].account = newValues.transactions[i].account.value
                      delete newValues.transactions[i].vatRate
                    }
                    this.props.onSlipUpdate({sign: this.props.slipData.sign, data: newValues, history: this.props.history});
                  }}
                >
                  {({errors, status, touched, values}) => (<Form>
                    <div className="modal-body">
                      <Row>
                        <Col lg="9" className="mb-1">
                          <FormGroup>
                            <Label htmlFor="qrvalue">
                              QR Value
                            </Label>
                            <Field
                              id="qrvalue"
                              name="qrvalue"
                              placeholder="Enter QR Value"
                              type="text"
                              className={"form-control" + (errors.qrvalue && touched.qrvalue ? " is-invalid" : "")}
                            />
                            <ErrorMessage
                              name="qrvalue"
                              component="div"
                              className="invalid-feedback"
                            />
                          </FormGroup>
                        </Col>
                        <Col lg="3" className="mb-1 border-end d-flex justify-content-end align-items-end">
                          <FormGroup>
                            <button className="btn btn-primary" type="button" onClick={() => this.onReprocess(values.qrvalue)}>
                              Reprocess
                            </button>
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg="3" className="mb-1">
                          <FormGroup>
                            <Label htmlFor="crn">
                              Crn
                            </Label>
                            <Field
                              id="crn"
                              name="crn"
                              placeholder="Enter Crn"
                              type="text"
                              className={"form-control" + (errors.crn && touched.crn ? " is-invalid" : "")}
                              onBlur={this.onBlurCrn}
                            />
                            <ErrorMessage
                              name="crn"
                              component="div"
                              className="invalid-feedback"
                            />
                          </FormGroup>
                        </Col>
                        <Col lg="3" className="mb-1" style={this.totalRowValidate(values)}>
                          <FormGroup>
                            <Label htmlFor="total">
                              Total
                            </Label>
                            <Field
                              id="total"
                              name="total"
                              placeholder="Enter Total"
                              type="number"
                              className={"form-control" + (errors.total && touched.total ? " is-invalid" : "")}
                            />
                            <ErrorMessage
                              name="total"
                              component="div"
                              className="invalid-feedback"
                            />
                          </FormGroup>
                        </Col>
                        <Col lg="6" className="mb-1">
                          <FormGroup>
                            <Label htmlFor="date">
                              Date
                            </Label>
                            <Field
                              id="date"
                              name="date"
                              placeholder="Enter Date"
                              type="datetime-local"
                              step="1"
                              className={"form-control" + (errors.date && touched.date ? " is-invalid" : "")}
                            />
                            <ErrorMessage
                              name="date"
                              component="div"
                              className="invalid-feedback"
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg="12" className="mb-1">
                          <hr/>
                        </Col>
                      </Row>
                      {this.state.select && this.state.select.vatRates && this.state.select.accounts && this.state.select.accounts.length > 0 && <FieldArray name="transactions">
                        {({insert, remove, push}) => {
                          return (
                            <div>
                              {values.transactions && values.transactions.length > 0 && values.transactions.map((transaction, index) => {
                                return (<div key={index}>
                                  <Row style={this.transactionRowValidate(transaction)}>
                                    <Col lg="3" className="mb-1">
                                      <FormGroup>
                                        <SelectField label="Vat Rate" name={`transactions.${index}.vatRate`}
                                                     options={this.state.select.vatRates}/>
                                      </FormGroup>
                                    </Col>
                                    <Col lg="7" className="mb-1">
                                      <FormGroup>
                                        <SelectField label="Account" name={`transactions.${index}.account`}
                                                     options={this.state.select.accounts}/>
                                      </FormGroup>
                                    </Col>
                                    <Col lg="2" className="mb-1 text-end">
                                      <Button color="danger" onClick={() => remove(index)}>-</Button>
                                    </Col>
                                    <Col lg="4" className="mb-1">
                                      <FormGroup>
                                        <Label htmlFor={`transactions.${index}.base`}>
                                          Base
                                        </Label>
                                        <Field
                                          id={`transactions.${index}.base`}
                                          name={`transactions.${index}.base`}
                                          placeholder="Enter Base"
                                          type="number"
                                          className={"form-control" + (errors.transactions && errors.transactions[index] && errors.transactions[index].base && touched.transactions && touched.transactions[index] && touched.transactions[index].base ? " is-invalid" : "")}
                                        />
                                        <ErrorMessage
                                          name={`transactions.${index}.base`}
                                          component="div"
                                          className="invalid-feedback"
                                        />
                                      </FormGroup>
                                    </Col>
                                    <Col lg="4" className="mb-1">
                                      <FormGroup>
                                        <Label htmlFor={`transactions.${index}.vat`}>
                                          Vat
                                        </Label>
                                        <Field
                                          id={`transactions.${index}.vat`}
                                          name={`transactions.${index}.vat`}
                                          placeholder="Enter Vat"
                                          type="number"
                                          className={"form-control" + (errors.transactions && errors.transactions[index] && errors.transactions[index].vat && touched.transactions && touched.transactions[index] && touched.transactions[index].vat ? " is-invalid" : "")}
                                        />
                                        <ErrorMessage
                                          name={`transactions.${index}.vat`}
                                          component="div"
                                          className="invalid-feedback"
                                        />
                                      </FormGroup>
                                    </Col>
                                    <Col lg="4" className="mb-1">
                                      <FormGroup>
                                        <Label htmlFor={`transactions.${index}.total`}>
                                          Total
                                        </Label>
                                        <Field
                                          id={`transactions.${index}.total`}
                                          name={`transactions.${index}.total`}
                                          placeholder="Enter Total"
                                          type="number"
                                          className={"form-control" + (errors.transactions && errors.transactions[index] && errors.transactions[index].total && touched.transactions && touched.transactions[index] && touched.transactions[index].total ? " is-invalid" : "")}
                                        />
                                        <ErrorMessage
                                          name={`transactions.${index}.total`}
                                          component="div"
                                          className="invalid-feedback"
                                        />
                                      </FormGroup>
                                    </Col>
                                  </Row>
                                  <Row>
                                    <Col lg="12" className="mb-1">
                                      <FormGroup>
                                        <Label htmlFor={`transactions.${index}.description`}>
                                          Description
                                        </Label>
                                        <Field
                                          id={`transactions.${index}.description`}
                                          name={`transactions.${index}.description`}
                                          placeholder="Enter Description"
                                          type="text"
                                          className={"form-control" + (errors.transactions && errors.transactions[index] && errors.transactions[index].description && touched.transactions && touched.transactions[index] && touched.transactions[index].description ? " is-invalid" : "")}
                                        />
                                        <ErrorMessage
                                          name={`transactions.${index}.description`}
                                          component="div"
                                          className="invalid-feedback"
                                        />
                                      </FormGroup>
                                    </Col>
                                  </Row>
                                </div>);
                              })}
                              <div className="me-auto">
                                <Button color="success" onClick={() => push({base: "", vatRate: this.state.select.vatRates[0], vat: "", total: "", account: this.state.select.accounts[0]})}
                                        className="m-1">+</Button>
                              </div>
                            </div>)
                        }}
                      </FieldArray>}
                      {(!this.state.select || !this.state.select.vatRates || !this.state.select.accounts || this.state.select.accounts.length === 0) && <Row>
                        <Col lg="12" className="mb-1">
                          No associated analytical accounts between supplier and customer.
                        </Col>
                      </Row>}
                    </div>
                    <div className="modal-footer">
                      {this.state.loadingUpdate && (<div className="spinner-border text-primary m-1 me-auto" role="status">
                        <span className="sr-only">Loading...</span>
                      </div>)}
                      {this.state.errorUpdate.length > 0 && (<Alert color="danger" role="alert" className="me-auto">
                        {this.state.errorUpdate}
                      </Alert>)}
                      <Button color="primary" type="submit">
                        Save
                      </Button>
                    </div>
                  </Form>)}
                </Formik>}
              </Col>
              <Col className="col-8" style={{"height": "85vh", "overflow": "scroll"}}>
                <FileViewer sign={this.props.slipData.sign} name={this.props.slipData.name}/>
              </Col>
            </Row>
            {this.state.loadingDetail && (<div className="d-flex justify-content-center">
              <div className="spinner-border text-primary" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>)}
            {this.state.errorDetail.length > 0 && (<div className="mt-3">
              <Alert color="danger" role="alert">
                {this.state.errorDetail}
              </Alert>
            </div>)}
          </CardBody>
        </Card>
      </Modal>
    </React.Fragment>)
  }
}

SlipDetailModal.propTypes = {
  onSlipDetail: PropTypes.func,
  onSlipSelect: PropTypes.func,
  onSlipUpdate: PropTypes.func,
  onSlipQRUpdate: PropTypes.func,
};

const mapStateToProps = ({Slip}) => ({
  responseDetail: Slip.responseDetail,
  loadingDetail: Slip.loadingDetail,
  errorDetail: Slip.errorDetail,
  responseSelect: Slip.responseSelect,
  loadingSelect: Slip.loadingSelect,
  errorSelect: Slip.errorSelect,
  responseUpdate: Slip.responseUpdate,
  loadingUpdate: Slip.loadingUpdate,
  errorUpdate: Slip.errorUpdate,
  responseQRUpdate: Slip.responseQRUpdate,
  loadingQRUpdate: Slip.loadingQRUpdate,
  errorQRUpdate: Slip.errorQRUpdate,
});

const mapDispatchToProps = dispatch => ({
  onSlipDetail: data => dispatch(slipDetail(data)),
  onSlipSelect: data => dispatch(slipSelect(data)),
  onSlipUpdate: data => dispatch(slipUpdate(data)),
  onSlipQRUpdate: data => dispatch(slipQRUpdate(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(SlipDetailModal));